export default __webpack_public_path__ + "static/media/dreamstime_s_87359540.8d1ab8ae.jpg";